module.exports = __webpack_public_path__ + "static/media/team-img-5.492a1949.jpg";